import { useTranslation } from 'react-i18next'
import type { MachineCharacteristicsExtractionTaskState } from '../utils/machineCharacteristicsExtractionTaskState'
import { MachineCharacteristicsExtractionProgress } from './MachineCharacteristicsExtractionProgress'

type OnboardingMachineCharacteristicsExtractionStepProps = {
  extractionTaskState: MachineCharacteristicsExtractionTaskState
  extractionError: string | null
}

export function OnboardingMachineCharacteristicsExtractionStep({
  extractionTaskState,
  extractionError,
}: OnboardingMachineCharacteristicsExtractionStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <>
      <div className='w-full max-w-lg space-y-4'>
        <h2 className='text-lg font-semibold text-foreground'>
          {t('onboarding.machineCharacteristicsExtraction.heading')}
        </h2>
        <p className='text-sm text-muted-foreground'>
          {t('onboarding.machineCharacteristicsExtraction.progressMessage')}
        </p>
        <MachineCharacteristicsExtractionProgress state={extractionTaskState} />
      </div>
      {extractionError ? (
        <p className='mt-8 text-center text-sm text-destructive' role='alert'>
          {extractionError}
        </p>
      ) : null}
    </>
  )
}
